import { supabase } from './supabaseClient';

export async function getLotsByChantier(chantierId) {
  const { data, error } = await supabase
    .from('lots')
    .select(`
      *,
      contact:contacts(id, name, email),
      lot_metiers(
        metier_id,
        metier:metier_id(id, name, color, icon)
      )
    `)
    .eq('chantier_id', chantierId)
    .is('deleted_at', null)
    .order('numero', { ascending: true });

  if (error) throw error;
  return data || [];
}

export async function updateLot(lotId, updates) {
  const { data, error } = await supabase
    .from('lots')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', lotId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function createLot(chantierId, { numero, nom, description, montant_previsionnel, date_debut_prevue, duree_jours }) {
  const { data, error } = await supabase
    .from('lots')
    .insert({
      chantier_id: chantierId,
      numero,
      nom,
      description: description ?? null,
      montant_previsionnel: montant_previsionnel ?? null,
      date_debut_prevue: date_debut_prevue ?? null,
      duree_jours: duree_jours ?? null,
      source: 'manuel',
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function purgeLot(lotId) {
  const { error: tasksError } = await supabase.from('chantier_tasks').delete().eq('lot_id', lotId);
  if (tasksError) throw tasksError;

  const { count: leftoverTasksCount, error: leftoverError } = await supabase
    .from('chantier_tasks')
    .select('id', { count: 'exact', head: true })
    .eq('lot_id', lotId);
  if (leftoverError) throw leftoverError;
  if (leftoverTasksCount && leftoverTasksCount > 0) {
    throw new Error(
      `${leftoverTasksCount} tâche(s) du lot ${lotId} n'ont pas pu être supprimées — vérifier les policies RLS sur "chantier_tasks".`
    );
  }

  const { error: metiersError } = await supabase.from('lot_metiers').delete().eq('lot_id', lotId);
  if (metiersError) throw metiersError;

  const { data, error } = await supabase.from('lots').delete().eq('id', lotId).select('id');
  if (error) throw error;
  if (!data || data.length === 0) {
    throw new Error(
      `Le lot ${lotId} n'a pas pu être supprimé (0 ligne affectée) — vérifier les policies RLS sur "lots".`
    );
  }
}

// Ajoute les nouveaux métiers, retire ceux qui ne sont plus sélectionnés.
export async function updateLotMetiers(lotId, metierIds) {
  const { data: current, error: fetchError } = await supabase
    .from('lot_metiers')
    .select('metier_id')
    .eq('lot_id', lotId);

  if (fetchError) throw fetchError;

  const currentIds = (current || []).map((m) => m.metier_id);
  const toAdd = metierIds.filter((id) => !currentIds.includes(id));
  const toRemove = currentIds.filter((id) => !metierIds.includes(id));

  if (toAdd.length > 0) {
    const { error } = await supabase
      .from('lot_metiers')
      .insert(toAdd.map((metierId) => ({ lot_id: lotId, metier_id: metierId })));
    if (error) throw error;
  }

  if (toRemove.length > 0) {
    const { error } = await supabase
      .from('lot_metiers')
      .delete()
      .eq('lot_id', lotId)
      .in('metier_id', toRemove);
    if (error) throw error;
  }
}
